var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.6,
    height: 18,
    viewBox: "0 0 15.6 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-line",
    transform: "translate(-5 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M15.2,11.4A4.2,4.2,0,1,0,11,7.2,4.2,4.2,0,0,0,15.2,11.4Zm0-7.2a3,3,0,1,1-3,3A3,3,0,0,1,15.2,4.2Z",
    transform: "translate(-2.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M20.282,22.223a10.3,10.3,0,0,0-14.958,0A1.2,1.2,0,0,0,5,23.045V26.2a1.2,1.2,0,0,0,1.2,1.2H19.4a1.2,1.2,0,0,0,1.2-1.2V23.045A1.2,1.2,0,0,0,20.282,22.223ZM19.4,26.2H6.2V23.039a9.1,9.1,0,0,1,13.2,0Z",
    transform: "translate(0 -6.401)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user.8ff29cf817d4cf2e09383bb00da5eb96.svg";